export const addPaddingToRect = (rect: DOMRect, padding: number) => {
  return new DOMRect(rect.left - padding, rect.top - padding, rect.width + padding * 2, rect.height + padding * 2);
};
